import React, { useState, useEffect, useCallback} from "react";
import {
  TextField,
  Button,
  ChoiceList,
  Filters,
  Icon,
  InlineStack,
} from "@shopify/polaris";
import intl from "../../../../../i18n/intl";
import {
  SearchMinor,
} from '@shopify/polaris-icons'
const Search = ({ data, onSearch }) => {
  const [queryValue, setQueryValue] = useState("");
  const [selectPublish, setSelectPublish] = useState(
    data?.searchParam?.selectPublish
  );
  const [selectProductStatus, setSelectProductStatus] = useState(
    data?.searchParam?.selectProductStatus
  );

  useEffect(() => {
    setSelectPublish(data?.searchParam?.selectPublish);
    setSelectProductStatus(data?.searchParam?.selectProductStatus)
  }, [data]);

  const handleSearch = () => {
    onSearch(
      {
        q: queryValue,
      }
    );
  };

  // 输入框搜索
  const changeInput = (value) => {
    setQueryValue(value);
    if (!value) {
      onSearch(
        {
          q: value,
        }
      );
    }
  };

  // 清空输入框
  const clearText = useCallback(() => {
    setQueryValue("");
    handleSearch();
    // eslint-disable-next-line
  }, []);

  // 状态筛选
  const changeStatus = (val, type) => {
    if ( type === "Import status") {
      setSelectPublish(val) 
      setSelectProductStatus(null)
    }else{
      setSelectProductStatus(val)
    }
    onSearch(
      type === "Import status"
        ? {
            selectPublish: val,
          }
        : {
            selectProductStatus: val,
          }
    );
    // eslint-disable-next-line
  };

  // 清除状态
  const clearStatus = useCallback((type) => {
    if (type === "selectProductStatus") {
      onSearch({
        selectProductStatus: [],
      });
      setSelectProductStatus(null);
    }else {
      onSearch({
        selectPublish: ['Not imported'],
      });
    }
    // eslint-disable-next-line
  }, []);

  // 导入状态筛选浮层选项
  // const importChoice = useMemo(() => {
  //   const activeImportChoice = [
  //     { label: intl.get("Not Listed"), value: "Not imported" },
  //     { label: intl.get("Listed"), value: "Imported" },
  //     { label: intl.get("Deleted"), value: "Deleted" },
  //   ];
  //   if (data?.recommend) {
  //     activeImportChoice.splice(1, 0, {
  //       label: intl.get("Recommend"),
  //       value: "Recommend",
  //     });
  //   }
  //   return activeImportChoice;
  // }, [data]);

  const filters = [
    // {
    //   key: "selectPublish",
    //   label: intl.get("List status"),
    //   filter: (
    //     <ChoiceList
    //       title={intl.get("List status")}
    //       titleHidden
    //       choices={importChoice}
    //       selected={selectPublish || []}
    //       onChange={(val) => changeStatus(val, "Import status")}
    //     />
    //   ),
    //   shortcut: true,
    //   hideClearButton: true,
    // },
    {
      key: "selectProductStatus",
      label: intl.get("Product status"),
      filter: (
        <ChoiceList
          title={intl.get("Product status")}
          titleHidden
          choices={[
            { label: intl.get("On Selling"), value: "On Selling" },
            { label: intl.get("Offline"), value: "Offline" },
          ]}
          selected={selectProductStatus || []}
          onChange={(val) => changeStatus(val, "Product status")}
        />
      ),
      shortcut: true,
    },
  ];

  const appliedFilters = [];
  if (!isEmpty(selectPublish)) {
    const key = "selectPublish";
    appliedFilters.push({
      key,
      label: disambiguateLabel(key, selectPublish),
      onRemove: () => clearStatus("selectPublish"),
    });
  }
  if (!isEmpty(selectProductStatus)) {
    const key = "selectProductStatus";
    appliedFilters.push({
      key,
      label: disambiguateLabel(key, selectProductStatus),
      onRemove: () => clearStatus("selectProductStatus"),
    });
  }
  const handleFiltersClearAll = () => {
    if (selectProductStatus.length > 0) {
      clearStatus("selectProductStatus")
    }
  };

  return (
    <div className="Search" style={{minHeight:'70px',paddingTop:8}}>
      <InlineStack algin='space-between'>
          <TextField
            labelHidden
            prefix={<Icon source={SearchMinor} />}
            value={queryValue}
            placeholder={intl.get("Filter products")}
            onChange={changeInput}
            clearButton
            onClearButtonClick={clearText}
            autoComplete="off"
            maxLength={500}
          />
          <Button variant="primary" onClick={handleSearch}>
            {intl.get("Find products")}
          </Button>
      </InlineStack>
      <Filters
        hideQueryField
        filters={filters}
        appliedFilters={appliedFilters}
        onClearAll={handleFiltersClearAll}
      />
        
    </div>
  );

  function disambiguateLabel(key, value) {
    if (value && value[0].indexOf('Not imported') !== -1) {
      value = ['Not Listed']
    }
    if (value && value[0].indexOf('Imported') !== -1) {
      value = ['Listed']
    }
    switch (key) {
      case "selectPublish":
        return value.map((val) => val);
      case "selectProductStatus":
        return value.map((val) => val);
      default:
        return value;
    }
  }

  function isEmpty(value) {
    if (Array.isArray(value)) {
      return value.length === 0;
    } else {
      return value === "" || value == null;
    }
  }
};

export default Search;
